import {
  Directive, EventEmitter, HostListener, Input, Output, inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DialogService } from 'src/app/@core/dialog.service';

@Directive({
  selector: '[confirm]',
  standalone: false,
})
export class ConfirmDirective {
  @Input() public skipDialog: boolean;
  @Input() public confirmHeader: string;
  @Input() public confirmMessage: string;
  @Input() public confirmButtonCancel: string;
  @Input() public confirmButtonConfirm: string;
  @Output() public confirm: EventEmitter<void> = new EventEmitter<void>();

  private dialogService = inject(DialogService);
  private translate = inject(TranslateService);

  @HostListener('click', ['$event'])
  public onClick(event: CustomEvent): void {
    event.stopPropagation();
    this.openDialog().catch();
  }

  private async openDialog(): Promise<void> {
    if (this.skipDialog) {
      this.confirm.emit();

      return Promise.resolve();
    }

    const confirmed = await this.dialogService.showConfirm({
      cancelButtonTitle: this.confirmButtonCancel || this.translate.instant('BUTTON.CANCEL'),
      message: this.confirmMessage || this.translate.instant('VIEW.COMMON.ALERT.CONFIRM.MESSAGE'),
      okButtonTitle: this.confirmButtonConfirm || this.translate.instant('BUTTON.OK'),
      title: this.confirmHeader || this.translate.instant('VIEW.COMMON.ALERT.CONFIRM.TITLE'),
    });

    if (confirmed) {
      this.confirm.emit();
    }

    return Promise.resolve();
  }
}
